import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';

const LogoutButton = () => {
    const navigate = useNavigate();
    const [showConfirm, setShowConfirm] = useState(false);

    const handleLogout = async () => {
        try {
            localStorage.removeItem('currentPaper');
            await signOut(auth);
            navigate('/');
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    return (
        <>
            <button
                onClick={() => setShowConfirm(true)}
                className="p-3 rounded-xl transition-colors text-red-400 hover:bg-red-600/10 
                         border border-transparent hover:border-red-500/20"
                title="Sign Out"
            >
                <LogOut className="w-5 h-5" />
            </button>

            {/* Centered Confirmation Dialog */}
            {showConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-gray-900 border border-red-500/20 rounded-lg p-6 shadow-lg max-w-sm w-full mx-4">
                        <h3 className="text-lg font-medium text-white mb-2">Sign Out</h3>
                        <p className="text-gray-300 mb-6">
                            Are you sure you want to sign out? Any unsaved changes will be lost.
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={handleLogout}
                                className="flex-1 px-4 py-2 bg-red-500/20 text-red-400 
                                         hover:bg-red-500/30 rounded-lg text-sm transition-colors"
                            >
                                Sign Out
                            </button>
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="flex-1 px-4 py-2 bg-gray-600/20 text-gray-300 
                                         hover:bg-gray-600/30 rounded-lg text-sm transition-colors"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LogoutButton; 